var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendEmailSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 50,
    fill: "none",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#send-email-solid_svg__clip0_1333_1112)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M29.553.245a4.05 4.05 0 015.192 5.19l-8.935 26.78a4.05 4.05 0 01-2.92 2.672 4.001 4.001 0 01-3.8-1.084l-4.795-4.773-5.035 2.605a1.25 1.25 0 01-1.825-1.143l.208-7.96L25.255 9.74a1.564 1.564 0 10-1.837-2.53L5.508 20.22l-4.325-4.325A4 4 0 01.09 12.278a4.05 4.05 0 012.673-3.096h.007L29.55.242l.003.003z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "send-email-solid_svg__clip0_1333_1112"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v35H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmailSolid);
export default ForwardRef;